module.exports = __webpack_public_path__ + "static/media/settings-icon.dea6ce1b.svg";